module.exports = __webpack_public_path__ + "static/media/noimage.f45d0b0f.gif";